// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  partner/src/App.js
//  Copy to: C:\quickry\partner\src\App.js
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing    from "./pages/Landing";
import Register   from "./pages/Register";
import Onboarding from "./pages/Onboarding";
import Dashboard  from "./pages/Dashboard";

function ProtectedRoute({ children }) {
  const { isLoggedIn, loading } = useAuth();
  if (loading) return (
    <div style={{ display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",background:"#0a0a0a",color:"#f97316",fontFamily:"sans-serif",fontSize:"1.2rem",fontWeight:700 }}>
      Loading...
    </div>
  );
  if (!isLoggedIn) return <Navigate to="/register" replace/>;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/"          element={<Landing/>}/>
      <Route path="/register"  element={<Register/>}/>
      <Route path="/onboarding" element={
        <ProtectedRoute><Onboarding/></ProtectedRoute>
      }/>
      <Route path="/dashboard" element={
        <ProtectedRoute><Dashboard/></ProtectedRoute>
      }/>
      <Route path="*" element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes/>
      </AuthProvider>
    </BrowserRouter>
  );
}